export function mapFirebaseDocsDataToObjects(docs) {
  let mapped_object = {};
  for (let i = 0; i < docs.length; i++) {
    const doc_data = docs[i].data();
    mapped_object[doc_data.id] = { ...doc_data };
  }
  return mapped_object;
}
